import { connect } from 'react-redux';
import HomePage from './HomePage';

const mapStateToProps = (state) => ({
  permissions: state.auth.permissions,
  hasAcceptedTC: state.auth.hasAcceptedTC,
});

export default connect(mapStateToProps, null)(HomePage);
